import { useQuery } from "@tanstack/react-query";
import { tamanhoService, TamanhoFilters } from "../services/tamanhoService";

export const useTamanhos = (filters?: TamanhoFilters) => {
  return useQuery({
    queryKey: ["tamanhos", filters],
    queryFn: () => tamanhoService.getTamanhos(filters),
  });
};
